export enum ExceptionsActionType {
  UNRESOLVED = 'Unresolved',
  CURRENT_RETURN = 'Included',
  ADJUSTMENT = 'Adjusted',
  DEFER = 'Deferred',
  DEFERRED_PREVIOUSLY = 'Unresolved (Previously Deferred)',
  OUT_OF_SYSTEM_ADJUSTED = 'OUT_OF_SYSTEM_ADJUSTED',
}

export type ExceptionsWrapper = {
  id: number | undefined;
  exceptionActionType: string;
  adjustmentPeriodId: string | null;
  adjustDate: string | null;
  applicationConnectionId: string | null;
};

export type AllExceptionsDetails = {
  actionType: string | null;
  adjustmentPeriodId: string | null;
  adjustDate: string | null;
  applicationConnectionId?: string | null;
};
